import * as React from 'react';
import { Rect, Group, Image} from 'react-konva';
import useImage from 'use-image';

import ImgBedPlov from '../assets/Machines/Bedplov.png'

export function MachinePlough({ x,y,furrowHeight, furrowWidth, bedWidth, furrows}) {
    const [imgBedPlov] = useImage(ImgBedPlov)

    return (
      <Group
        x={x}
        y={y}
        draggable={true}
      >       
        {Array(furrows).fill().map((e, i) => {    
            return(<Image x={i*bedWidth} y={0} width={furrowWidth} height={furrowHeight} image={imgBedPlov} key={i}/>)
        })}
      </Group>
    );
  }

